import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { endPoints, paymentEndpoints } from "../../../constant/Environment";
import { deleteData, getAllPaymentFilterData } from "../../../Utility/API";
import { Form, Button } from "react-bootstrap";
import TransactionsSummarySearch from "../../../components/FilterComponent/TransactionsSummarySearch";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Actions } from "../../../redux/Actions/Actions";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
const TransactionsSummary = () => {
  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoadinig] = useState(false);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  

    const filteredItems = {
    name: "",
    platform:"1",
    status:"",
    regdate: "",
    state: "",
    city: "",
    accounNumber:""
  };

  
  function getNumberOfPages(rowCount, rowsPerPage) {
    return Math.ceil(rowCount / rowsPerPage);
  }
  
  function toPages(pages) {
    const results = [];
    for (let i = 1; i <= pages; i++) {
      results.push(i);
    }
  
    return results;
  }


  const columns = [
    {
      name: "Casino Name",
      selector: (row) => row.casinoName,
      sortable: true,
    },
    {
      name: "Transaction Type",
      selector: (row) => row.transactionType,
      sortable: true,
    },
    {
      name: "Transactions Number",
      selector: (row) => row.transactionsNumber,
      sortable: true,
    },
    {
      name: "Total Amount",
      selector: (row) => row.totalAmount,
      sortable: true,
    },
    {
      name: "Total Fee",
      selector: (row) => row.totalFee,
      sortable: true,
    },
    {
      name: "Grand Total",
      selector: (row) => row.grandTotal,
      sortable: true,
    },
    {
      name: "Casino Id",
      selector: (row) => row.casinoId,
      sortable: true,
    }
  ];

  // RDT exposes the following internal pagination properties
const BootyPagination = ({
  rowsPerPage,
  rowCount,
  onChangePage,
  onChangeRowsPerPage, // available but not used here
  currentPage
}) => {
  const handleBackButtonClick = () => {
    onChangePage(currentPage - 1);
  };

  const handleNextButtonClick = () => {
    onChangePage(currentPage + 1);
  };

  const handlePageNumber = (e) => {
    onChangePage(Number(e.target.value));
  };

  const pages = getNumberOfPages(rowCount, rowsPerPage);
  const pageItems = toPages(pages);
  const nextDisabled = currentPage === pageItems.length;
  const previosDisabled = currentPage === 1;

  return (
    <nav>
      <ul className="pagination">
        <li className="page-item">
          <button
            className="page-link"
            onClick={handleBackButtonClick}
            disabled={previosDisabled}
            aria-disabled={previosDisabled}
            aria-label="previous page"
          >
            Previous
          </button>
        </li>
        {pageItems.map((page) => {
          
          const className =
            page === currentPage ? "page-item active" : "page-item";

          return (
            <li key={page} className={className}>
              <button
                className="page-link"
                onClick={handlePageNumber}
                value={page}
              >
                {page}
              </button>
            </li>
          );
        })}
        <li className="page-item">
          <button
            className="page-link"
            onClick={handleNextButtonClick}
            disabled={nextDisabled}
            aria-disabled={nextDisabled}
            aria-label="next page"
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};


 


  useEffect(() => {
    fetchUserData(filteredItems);
  }, []);

  const fetchUserData = async (data) => {
    let url = `${paymentEndpoints.api.TRANSACTION_SUMMARY_LIST}`;
    await getAllPaymentFilterData(url,data)
      .then((response) => {
        console.log("data", response.status);
        if (response.status === "success") {
          setRows(response.data);
          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const create = () => {
    navigate("/CreateUser");
  }
  const searchList = (filterObj) => {
    //fetchUserData(filterObj);
  }
  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{padding:'0px'}}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="mb-2">Transactions Detail</h2>
                </div>
              </div>
              <div
                className="row"
                style={{ padding: "5px 0px 20px 0px" }}
              >
                 <div className="col-md-12">
                 <TransactionsSummarySearch report={paymentEndpoints.api.TRANSACTION_SUMMARY_REPORT} searchList={searchList}></TransactionsSummarySearch>
                </div>
              
                </div>
                <div className="container-fluid table-custom">
              <div
                className="row"
                style={{  padding: "5px 0px 20px 0px" }}
              >
               
               <div className="col-md-12">
                <DataTable
          title=""
          columns={columns}
          data={rows}
          defaultSortFieldID={1}
          pagination
          paginationComponent={BootyPagination}
          paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
          // subHeader
          // subHeaderComponent={subHeaderComponentMemo}
        />

               </div>
               </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionsSummary;
